import { toast } from "react-toastify";
import React from "react";
const WarningMessage = (msg) => {
    return (
        <>
            {toast.warn(msg, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            })}
        </>
    )

}
export default WarningMessage;